import React from 'react';
import Link from 'components/Link';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import WithGeo from 'helpers/ads/WithGeo';
import s from './NavList.scss';
import ButtonPreferredSources from '../ButtonPreferredSources';

/**
 * Functional Component used for rendering List of Links only which are having Link and WU mainly on the UI.
 * e.g. Promotional L2 component having only Label / link in Desktop Header
 * Will appear only in the Desktop below the navigation.
 * will be read from the promotionalL2:{label:'<label>',items:[{hl,wu},{hl,wu},{hl,wu}]}
 * @param {*} props
 */
export default function NavList(props) {
  const { data, hideLabel } = props;
  if (data) {
    const { items } = data;
    if (!(Array.isArray(items) && items.length > 0)) {
      return null;
    }

    const scrollToDiv = divId => {
      const targetDiv = document.getElementById(divId);

      if (targetDiv) {
        targetDiv.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    };

    return (
      <div className={s.InnewsLink}>
        {!hideLabel && (
          <span>
            In the <h1>News</h1>
          </span>
        )}
        <ul className={s.list}>
          {items.map((val, index) => (
            <li
              key={index}
              className={classNames({
                [s[val.className]]: val && val.className,
                [s[val.hl && val.hl.toLowerCase()]]:
                  val.hl && val.hl.toLowerCase() === 'medithon',
              })}
            >
              {val.scrollToId && !val.wu ? (
                <div
                  className={s.navButton}
                  onClick={() => {
                    scrollToDiv(val.scrollToId);
                  }}
                >
                  {val.hl}
                </div>
              ) : (
                <Link
                  to={val.wu}
                  ga4Data={[
                    {
                      event: 'user_click',
                      type: 'header',
                      category: 'l2',
                      label: (val?.hl || val?.label).toLowerCase(),
                    },
                  ]}
                  data-newga={`InTheNewsSection_Actions#Click/${val.hl}/${
                    val.wu
                  }`}
                >
                  {val.hl}
                </Link>
              )}
            </li>
          ))}
        </ul>
        <WithGeo
          render={({ geoCountry }) =>
            geoCountry === 'US' || geoCountry === 'IN' ? (
              <div className={s.innewsLinkinfoCol}>
                <ButtonPreferredSources label="homepage_web" />
              </div>
            ) : null
          }
        />
      </div>
    );
  }
  return null;
}
/**
 * Prop types defined for the Component
 */
NavList.propTypes = {
  data: PropTypes.shape({}).isRequired,
  hideLabel: PropTypes.bool,
};

NavList.defaultProps = {
  hideLabel: false,
};
